import styled from 'styled-components';
import { matchScreen } from '@Utils/layout/layoutSupport';

export const ModalWrapper = styled.div`
	padding: ${() => (matchScreen(['xs']) ? '0' : '16px')};
`;
